import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menulvl3",
  "use": "icon-menulvl3-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-circle fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-menulvl3\"><path fill=\"currentColor\" d=\"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol